import { RequestKind, boolean, string } from '@sb/library/base';
import { DisplayItemCollection, LendingLibraryHistorySearchOptions, LendingLibrarySearchOptions, LibraryLendingDisplayItem, LibraryLendingInputItem, LibraryLendingItemHistoryDisplayItem, LibraryLendingLoanInputItem, LibraryLoanDeleteOptions, LoanedItemsSearchOptions } from '@sb/library/data-models';
import { ApiRoute } from '../api-route';

export namespace LendingLibraryRoutes {
    export const Get = ApiRoute.Define({
        URL: (itemID: string) => `lendinglibrary/${itemID}`,
        Kind: RequestKind.Get,
        ResultType: LibraryLendingDisplayItem
    });

    export const GetAll = ApiRoute.Define({
        URL: `lendinglibrary`,
        Kind: RequestKind.Get,
        ResultType: DisplayItemCollection<LibraryLendingDisplayItem>
    });

    export const Add = ApiRoute.Define({
        URL: 'lendinglibrary',
        Kind: RequestKind.Post,
        BodyType: LibraryLendingInputItem,
        ResultType: string
    });

    export const Update = ApiRoute.Define({
        URL: (itemID: string) => `lendingLibrary/${itemID}`,
        Kind: RequestKind.Put,
        BodyType: LibraryLendingInputItem,
        ResultType: boolean
    });

    export const Delete = ApiRoute.Define({
        URL: (itemID: string) => `lendinglibrary/${itemID}`,
        Kind: RequestKind.Delete,
        ResultType: boolean
    });

    export const Search = ApiRoute.Define({
        URL: 'search/lendinglibrary',
        Kind: RequestKind.Post,
        BodyType: LendingLibrarySearchOptions,
        PagingAllowed: true,
        ResultType: DisplayItemCollection<LibraryLendingDisplayItem>
    });

    export namespace LoanItems {
        export const Get = ApiRoute.Define({
            URL: `loaneditems`,
            Kind: RequestKind.Get,
            ResultType: DisplayItemCollection<LibraryLendingDisplayItem>
        });

        export const Add = ApiRoute.Define({
            URL: (itemID: string) => `loaneditems/${itemID}`,
            Kind: RequestKind.Post,
            BodyType: LibraryLendingLoanInputItem,
            ResultType: boolean
        });

        export const Delete = ApiRoute.Define({
            URL: (itemID: string) => `loaneditems/${itemID}`,
            Kind: RequestKind.Delete,
            BodyType: LibraryLoanDeleteOptions,
            ResultType: boolean
        });

        export const Search = ApiRoute.Define({
            URL: `search/loaneditems`,
            Kind: RequestKind.Post,
            PagingAllowed: true,
            BodyType: LoanedItemsSearchOptions,
            ResultType: DisplayItemCollection<LibraryLendingDisplayItem>
        });
    }

    export namespace History {
        export const Get = ApiRoute.Define({
            URL: (itemID: string) => `loanedhistory/${itemID}`,
            Kind: RequestKind.Get,
            ResultType: LibraryLendingItemHistoryDisplayItem
        });

        export const GetAll = ApiRoute.Define({
            URL: (itemID: string) => `loanedhistory`,
            Kind: RequestKind.Get,
            ResultType: LibraryLendingItemHistoryDisplayItem
        });

        export const Search = ApiRoute.Define({
            URL: `search/loanedhistory`,
            Kind: RequestKind.Post,
            BodyType: LendingLibraryHistorySearchOptions,
            ResultType: DisplayItemCollection<LibraryLendingItemHistoryDisplayItem>,
            PagingAllowed: true
        });
    }
}
